import Utillity from './utility'

const initialiseMiniApp = () => {
  if (Utillity.checkIfIsGpay()) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://microapps.google.com/apis/v1alpha/microapps.js'
    document.body.appendChild(script)
  }
}

export default initialiseMiniApp;
